if (typeof exports === 'object') {
    module.exports = {
        // 客户端版本号
        clientVersion: '',
        
        // 是否pc迅雷
        isPcXunlei: false,
        
        // 是否pc迅雷7
        isPcXunlei7: false,
        
        // 是否pc迅雷9
        isPcXunlei9: false,
        
        // 是否mac迅雷
        isMacXunlei: false,
        
        peerID: null,
        
        sessionID: null
    };
}


//////////////////
// WEBPACK FOOTER
// ./static/1.0/js/page/dev/modules/global.js
// module id = 3
// module chunks = 1 2 3 5 6 7 8 9 10 11 12